
<template>
    <div>
        <input-label v-if="label" :label="label" :isRequired="isRequired"></input-label>
        <select
            :id="id"
            ref="input"
            v-model="selected"
            v-bind="$attrs"
            class="form-control font-poppins"
            :class="error ? 'is-invalid' : isValidated ? 'is-valid' : ''">
            <slot />
        </select>
        <form-error :error="error"></form-error>
    </div>
</template>

<script>
import FormError from "@/Shared/FormError";
import InputLabel from "@/Shared/InputLabel";
export default {
    components: {
        FormError,
        InputLabel,
    },
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `select-input-${this._uid}`
            },
        },
        value: [String, Number, Boolean],
        label: String,
        error: [String, Array],
        isValidated: Boolean,
        isRequired: Boolean,
    },
    data() {
        return {
            selected: this.value,
        }
    },
    watch: {
        selected(selected) {
            this.$emit('input', selected)
        },
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
    },
}
</script>
